<!--[ngClass]="{'teacher-mute': remoteTeacherInfo.video.isMuted || !isCurrentUserOnline}" -->
<div class="unmute-classroom d-flex justify-content-center align-items-center ng-scope"
     *ngIf="classroom.isRoomMutedBecauseOfCurrentUserBlockedMicAndCam"
     (click)="handleClassroomUnmuteButtonClick()">
  <img src="assets/img/wrtc/speaker-off.svg" width="90" style="cursor: pointer" alt="">
</div>
